export const media = {
    labels: {
        media: "Mídia",
        medias: "Mídias",
        code: "Código",
        description: "Descrição",
        edit_media: "Editar Mídia",
        name: "Nome",
        slug: "Slug",
    },
    placeholders: {
        code: "Exe: BR",
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_media: "Adicionar Mídia",
            edit_media: "Editar Mídia",
            del_media: "Excluir Mídia",
        },
        messages: {
            del_media: "Você deseja mesmo excluir a mídia <strong>{name}</strong>?<br/>Todos os relacionamentos desta mídia serão excluídos.",
        },
    },
    texts: {
    },
};
